import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { createVuetify } from "vuetify";

export default createVuetify({
  theme: {
    defaultTheme: "waizmann",
    themes: {
      waizmann: {
        dark: false,
        colors: {
          background: "#FFFFFF",
          surface: "#FFFFFF",
          primary: "#2C5B9E",
          secondary: "#1A3D6B",
          accent: "#2C5B9E",
          info: "#2C5B9E",
          success: "#4CAF50",
          warning: "#FECF0C",
          error: "#E54C39",
        },
      },
    },
  },
  defaults: {
    VBtn: {
      style: "text-transform: none; letter-spacing: 0;",
    },
  },
});
